import { HoveredPointTooltip } from './HoveredPointTooltip/HoveredPointTooltip.js';
import { useRectData } from '../../hooks/useRectData.js';
import type {
  RectDatapointInternal,
  RectSeriesWithDatapoints,
} from '../../types/xy-chart-internals.js';

export function RectSeriesTooltip({
  datapoint,
  series,
}: Readonly<{
  datapoint: RectDatapointInternal;
  series: RectSeriesWithDatapoints;
}>) {
  const { seriesToMetadata } = useRectData();

  return (
    <HoveredPointTooltip
      datapoint={datapoint}
      series={series}
      seriesToMetadata={seriesToMetadata}
    />
  );
}
